const riskAssessment = {
  assignRisk: 'Assegna rischio',
  assignedRiskProfile: 'Profilo di rischio assegnato',
  cdd: 'CDD',
  confirmRisk:
    'Questo è l\'attuale indicatore di rischio calcolato. Confermi l\'attribuzione del valore calcolato?',
  customRiskProfile: 'Profilo di rischio personalizzato',
  dueDiligence: 'Due Diligence',
  edd: 'EDD',
  factorWeight: 'Peso del fattore',
  notarizeCdd: 'Notarizza Basic Customer Due Diligence',
  notarizeEdd: 'Notarizza Enhanced Customer Due Diligence',
  profilerData: 'Dati del profiler',
  questionnaire: 'Questionario',
  riskAssessment: 'Risk assessment',
  riskLevel: 'Livello di rischio',
  updateRisk: 'Aggiorna rischio',
};

export default riskAssessment;
